import moment from 'moment';
import { TIMESLOT_SAVE_REQUEST, TIMESLOT_SAVE_SUCCESS, TIMESLOT_SAVE_FAILURE } from '../../constants/types';
import { HTTP_METHOD } from '../../constants/methods';
import globals from '../../../globals/communityGlobals';

export function saveTimeSlotsPackage(timeSlots) {
  return {
    types: [TIMESLOT_SAVE_REQUEST, TIMESLOT_SAVE_SUCCESS, TIMESLOT_SAVE_FAILURE],
    buildCallParameters: () => ({
      method: HTTP_METHOD.POST,
      path: 'v1/command/ConfigureTimeSlots',
      data: {
        timeSlots: timeSlots.map(t => ({
          ...t,
          to: moment(t.to).format(globals.timeFormats.long),
          from: moment(t.from).format(globals.timeFormats.long),
        })),
      },
    }),
  };
}
